<template>
  <div class>
    <div class="ba_f pad_20">
      <div class="pagetitle mar_b20">{{ $t('plugin.classify.title') }}</div>
      <div class="t_l mar_b20 mar_t20">
        <el-button type="primary" size="medium" @click="handleEdit">{{ $t('plugin.classify.add') }}</el-button>
      </div>
    </div>
    <el-table v-loading="listLoading" :element-loading-text="loadingText" :data="list" stripe style="width: 100%">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="name" :label="$t('plugin.classify.name')"></el-table-column>
      <el-table-column :label="$t('common.operation')">
        <template slot-scope="scope">
          <div class="flex">
            <el-button type="text" @click="handleEdit(scope.row)">{{ $t('common.edit') }}</el-button>
            <el-button type="text" @click="handleDelete(scope.row)">{{ $t('common.delete') }}</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="page.total"
      :page-size="page.pagesize"
      :current-page.sync="page.currentPage"
      @current-change="handleCurrentChange"
    ></el-pagination>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="600px" @close="dialogVisible = false">
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item :label="$t('plugin.classify.name')" prop="name">
          <el-input v-model.trim="form.name" autocomplete="off" :placeholder="$t('plugin.classify.namePh')"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="save">{{ $t('common.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { typeList, typeSave, typeDelete } from '@/api/plugins';
export default {
  name: 'classify',
  data() {
    return {
      item: '',
      list: [],
      listLoading: true,
      form: {
        id: '',
        name: '',
        item: '',
      },
      title: '',
      dialogVisible: false,
      page: {
        total: 0,
        pagesize: 10,
        currentPage: 1,
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.$route.query.item == '2') {
        this.item = '2';
        this.form.item = '2';
      } else {
        this.item = '3';
        this.form.item = '3';
      }
      this.fetchData();
    },
    handleEdit(row) {
      if (row && row.id) {
        this.title = this.$t('plugin.classify.edit');
        this.form = Object.assign({}, this.form, row);
      } else {
        this.title = this.$t('plugin.classify.add');
        this.form = { id: '', name: '', item: this.item };
      }
      this.dialogVisible = true;
    },
    handleDelete(row) {
      if (row.id) {
        this.$baseConfirm(this.$t('confirm.deleteItem'), null, async () => {
          const { msg } = await typeDelete({ id: row.id });
          this.$baseMessage(msg, 'success');
          this.fetchData();
        });
      }
    },
    close() {
      this.$refs.form.resetFields();
      this.form = { id: '', name: '', item: this.item };
      this.dialogVisible = false;
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const { msg } = await typeSave(this.form);
          this.$baseMessage(msg, 'success');
          this.fetchData();
          this.close();
        }
      });
    },
    async fetchData() {
      const { data } = await typeList({ item: this.item });
      this.list = data || [];
      this.listLoading = false;
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
    },
  },
};
</script>
